"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWaveScope } from "@/generated/models/ApiWaveScope";
import WaveGroupTitle from "./WaveGroupTitle";
import WaveGroupEditButtons from "./edit/WaveGroupEditButtons";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiWave } from "@/generated/models/ApiWave";
import { canEditWave } from "@/helpers/waves/waves.helpers";
import WaveGroupScope from "./WaveGroupScope";
import type { WaveGroupType } from "./WaveGroup.types";
export default function WaveGroup(t0) {
  const $ = _c(20);
  const {
    scope,
    type,
    wave
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile || $[2] !== scope.group?.is_direct_message || $[3] !== wave) {
    t1 = canEditWave({
      connectedProfile,
      activeProfileProxy,
      wave
    }) && !scope.group?.is_direct_message;
    $[0] = activeProfileProxy;
    $[1] = connectedProfile;
    $[2] = scope.group?.is_direct_message;
    $[3] = wave;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const showEdit = t1;
  let t2;
  if ($[5] !== type) {
    t2 = <div className="tw-flex tw-gap-x-4"><WaveGroupTitle type={type} /></div>;
    $[5] = type;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== scope.group) {
    t3 = scope.group ? <WaveGroupScope group={scope.group} /> : <span className="tw-text-sm tw-font-medium tw-text-iron-50">Anyone</span>;
    $[7] = scope.group;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== scope.group || $[10] !== showEdit || $[11] !== type || $[12] !== wave) {
    t4 = showEdit && <div className="tw-flex tw-items-center"><WaveGroupEditButtons wave={wave} type={type} haveGroup={!!scope.group} /></div>;
    $[9] = scope.group;
    $[10] = showEdit;
    $[11] = type;
    $[12] = wave;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-2">{t3}{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t2 || $[18] !== t5) {
    t6 = <div className="tw-group tw-relative tw-flex tw-w-full tw-items-center tw-justify-between tw-px-2 tw-py-1 tw-text-sm">{t2}{t5}</div>;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}